(function($){
    'use strict';

    /*
     * On page search is used on the FAQ page to search through the questions and
     * display the ones that match
     */
     function initOnpageSearch() {
        var $searchForm = $('#faq-search-term');

        if($searchForm.length > 0){
            // no way to kill this thing...
            $searchForm.hideseek({
                list: '.faq-item',
                nodata: 'Geen resultaten gevonden probeer opnieuw',
                highlight : true
            });
            // remove old events first...

            // Events to do extra things after a search
            $searchForm.off('_after', afterFAQSearch);

            // Prevent the faq search form from submitting
            $(document.body).off('submit', '#faq-search', prevenSubmit);

            $(document.body).off('keyup', '#faq-search-term', checkEnter);

            // Now add the new events to the newly found global context

            // Events to do extra things after a search
            $searchForm.on('_after', afterFAQSearch);

            // Prevent the faq search form from submitting
            $(document.body).on('submit', '#faq-search', prevenSubmit);

            $(document.body).on('keyup', '#faq-search-term', checkEnter);
        }
    }

    function afterFAQSearch(){
      // show full questions that are found

      // Every valid search result has a highlight so we can fetch results of of that
      var $highlight = $('.faq-item .highlight');
      if($(this).val() === ''){
        $('.faq-item .no-results').remove();
        $('.faq-item').show();
      }

      if($('.faq-item .no-results').length === $('.faq-item').length){
        $('.faq-no-results').remove();
        $('.faq-item').hide();
        $('#faq-search').after('<p class="faq-no-results">Geen zoekresultaten gevonden</p>');
      }else {
        // no results
        $('.faq-no-results').remove();
        $('.faq-item').show();
      }
    }
    function checkEnter(ev) {
        // check for the enter key
        if(ev.keyCode === 13){
            ev.preventDefault();

            $(this).blur();

            return false;
        }
    }
    function prevenSubmit(ev) {
        ev.preventDefault();
        return false;
    }

    module.exports = initOnpageSearch;
}(jQuery));
